import InviteComponent from "@/components/InviteComponent";
import MoreComponent from "@/components/More";
import { Block, BlockRounded, Circle, Close, Login, MoreVert } from "@mui/icons-material";
import {
    Autocomplete,
    Box,
    Button,
    Chip,
    MenuItem,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Link,
    Paper,
    TableContainer
  } from "@mui/material";
import { fontSize } from "@mui/system";
import { inviteUserRequest, User as UserResponse, useSendUserInviteRequest, useUsersRequest, useUserUpdateRequest } from "apiRequests/users";
import { BlocksIcon, CheckCircle, CheckIcon, Eye, MailIcon, MailsIcon, User } from "lucide-react";
import { borderRadius } from "polished";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import MaterialIcons from "../icons/MaterialIcons";
import ModalCompontent from "@/components/ModalComponent";
import useAuth from "@/hooks/useAuth";



const UsersPage = () => {
    const {user} = useAuth()
    
    let { data, loading, error, refetch }  = useUsersRequest(user)
    if (typeof data === "string") {
        console.log("Data is a string:", data)
        data = undefined
    }
    // const [{data: userInvite}, inviteUserRequest] = useUserInviteRequest()
    const [, updateUserRequest] = useUserUpdateRequest()
    const [, sendUserInviteRequest] = useSendUserInviteRequest()
    const activeUsers = data?.filter((user) => 
        user.isLocked == false
        && (!!user?.isReady || (!!user?.answer?.data?.survey?.personalInformation && !!user?.answer?.data?.survey?.academics))
    )
    
    const navigate = useNavigate()
    const [state, setState] = useState({
        modalOpen: false,
        modalType: "invite",
    });

    const handleClickOpen = (modalType: "inviteUser") => {
        setState({ ...state, modalOpen: true, modalType});
    };

    const handleClose = () => {
        setState({ ...state, modalOpen: false });
    };

    const handleSubmit = async (emails: string[]) => {
        try {
            await inviteUserRequest(user, {
                emails
            })
            handleClose()
            refetch()
        } catch (error) {
            console.error(error)
        }
    }

    const handleLock = async (userId: string, value: boolean) => {
        await updateUserRequest(user, {userId, isLocked: value})
        refetch()
    }

    const handleResendInvite = async (userId: string) => {
        await sendUserInviteRequest(user, {userId})
        refetch()
    }

    
    
    const users = data?.sort((a?: UserResponse, b?: UserResponse)=>(
        (a?.id ?? "") > (b?.id ?? "") ? -1 : 1
    ))

    return (
        <>
            <ModalCompontent
                open={state.modalOpen}
                onClose={handleClose}
            >
                <div style={{paddingTop: 10}}>
                    <div onClick={handleClose} style={{float: "right", cursor: "pointer"}}><Close /></div>
                    <Typography id="modal-modal-title" variant="h4" component="h2">
                        Invite Users
                    </Typography>
                </div>

                <br />
                <InviteComponent onSubmit={handleSubmit} />
            </ModalCompontent>
            <Button onClick={handleClickOpen.bind(null, "inviteUser")} variant="contained" color="primary" sx={{ float: 'right' }}>
                Invite User
            </Button>
            <Typography variant="h4" gutterBottom>
                Users
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {activeUsers?.length?.toString()} active users found
            </Typography>
            <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                <Table stickyHeader>
                <TableHead>
                    <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell align="center">Assessment</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users?.map((row) =>{
                        
                        const isReady = !!row?.isReady || (!!row?.answer?.data?.survey?.personalInformation && !!row?.answer?.data?.survey?.academics)
                        let color :  "success" | "error" | "warning" = "success"
                        let status = "Active"
                        if(!row.isActive){
                            color = "warning"
                            status = "Pending"
                        }
                        
                        if (isReady){
                            color = "success"
                            status = "Active"
                        }
                        if(row.isLocked){
                            color = "error"
                            status = "Revoked"
                        }
                        
                        return  (
                            <TableRow key={row.id}>
                                <TableCell>
                                    <Link href={`/users/${row.id}`} style={{display: "block"}}>            
                                        <div style={{float: "left", display: "flex", width: "3em", height: "3em", borderRadius: "50%", backgroundColor: "#efefef", alignItems: "center", justifyContent: "center"}}>
                                            <User color="#aabbff" />
                                        </div>
                                        <div style={{verticalAlign: "middle", paddingLeft: 60}}>
                                            {row.firstName && row.lastName ? (
                                                <>
                                                    <div>
                                                        {row.firstName}&nbsp;{row.lastName}
                                                    </div>
                                                    {row.email}
                                                </>
                                            ):(
                                                <div style={{paddingTop: ".5em"}}>
                                                    {row.email}
                                                </div>
                                            )}
                                        </div>
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    {row.answer?.data?.survey?.academics?.city} {row.answer?.data?.survey?.academics?.state} {row.answer?.data?.survey?.personalInformation?.zipcode}
                                </TableCell>
                                <TableCell align="center">
                                    {isReady ? (
                                        <Link href={`/users/${row.id}`}>
                                            <CheckIcon color="#22aa22" />
                                        </Link>
                                    ) : (
                                        <CheckIcon color="#bebebe" />
                                    )}
                                </TableCell>
                                <TableCell>
                                    <Chip label={<div><Circle style={{fontSize: 8, verticalAlign: "middle"}} /> {status}</div>} color={color} size="small" style={{borderRadius: 15}} variant="outlined" />
                                </TableCell>
                                <TableCell>
                                    <MoreComponent>
                                        {isReady && (
                                            <MenuItem onClick={()=>navigate(`/users/${row.id}`)}>
                                            <Eye size={18} /> &nbsp;View Details
                                            </MenuItem>
                                        )}
                                        {row.email && (
                                            <MenuItem onClick={()=>navigate(`/users/${row.email}/authentications`)}>
                                                <Login style={{fontSize: 18}} /> &nbsp;View Logins
                                            </MenuItem>
                                        )}
                                        {!isReady && (
                                            <MenuItem onClick={handleResendInvite.bind(null, row.id)}>
                                                <MailIcon size={18} /> &nbsp;Resend Invite
                                            </MenuItem>
                                        )}
                                        {row.isLocked ?(
                                            <MenuItem onClick={handleLock.bind(null, row.id, false)}style={{color: "rgb(46, 125, 50)"}}>
                                                <CheckCircle size={18} /> &nbsp;Grant Access
                                            </MenuItem>     
                                        ):(
                                            <MenuItem onClick={handleLock.bind(null, row.id, true)} style={{color: "rgb(211, 47, 47)"}}>
                                                <Block style={{fontSize: 18}} /> &nbsp;Revoke Access
                                            </MenuItem>
                                        )}
                                    </MoreComponent>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
export default UsersPage;